import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { Check, ShieldCheck } from 'lucide-react';
export function PriceSection() {
  const stack = [{
    name: 'Libro completo de ADC',
    price: '$15.000'
  }, {
    name: 'Guías de campeones',
    price: '$5.000'
  }, {
    name: 'Checklists y tablas',
    price: '$3.000'
  }, {
    name: 'Bonus exclusivos',
    price: '$6.999'
  }];
  return <section id="comprar" className="py-20 bg-[#0d1117] relative overflow-hidden" data-id="element-71">
      <div className="absolute inset-0 bg-blue-900/5 pointer-events-none" data-id="element-72" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-73">
        <div className="text-center mb-12" data-id="element-74">
          <h2 className="text-4xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-75">
            Invertí en tu juego
          </h2>
          <p className="text-xl text-red-400 font-bold animate-pulse" data-id="element-76">
            🔥 ÚLTIMOS DÍAS DE DESCUENTO 🔥
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#161b22] border-2 border-amber-500/50 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(245,158,11,0.15)] relative" data-id="element-77">
          {/* Badge */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-amber-500 to-orange-600 text-white px-6 py-2 rounded-full font-bold uppercase tracking-wider shadow-lg" data-id="element-78">
            Oferta Especial
          </div>

          {/* Stack */}
          <div className="space-y-4 mb-10 max-w-lg mx-auto" data-id="element-79">
            {stack.map((item, i) => <div key={i} className="flex justify-between items-center text-lg md:text-xl border-b border-gray-800 pb-2" data-id="element-80">
                <span className="text-gray-300 flex items-center gap-2" data-id="element-81">
                  <Check className="w-5 h-5 text-green-500" data-id="element-82" />
                  {item.name}
                </span>
                <span className="text-red-500 line-through font-medium opacity-70" data-id="element-83">
                  {item.price}
                </span>
              </div>)}
            <div className="flex justify-between items-center text-xl font-bold pt-2" data-id="element-84">
              <span className="text-white" data-id="element-85">Valor Total</span>
              <span className="text-red-500 line-through decoration-2" data-id="element-86">
                $29.999
              </span>
            </div>
          </div>

          {/* Price Highlight */}
          <div className="text-center mb-10 bg-gray-900/50 p-6 rounded-xl border border-gray-700" data-id="element-87">
            <p className="text-gray-400 mb-2 uppercase tracking-wide font-bold text-sm" data-id="element-88">
              Hoy todo por solo
            </p>
            <div className="text-6xl md:text-7xl font-black text-amber-400 tracking-tighter drop-shadow-lg" data-id="element-89">
              $7.999{' '}
              <span className="text-2xl text-amber-200 font-bold" data-id="element-90">ARS</span>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col items-center gap-6" data-id="element-91">
            <CtaButton text="COMPRAR AHORA - $7.999 ARS" subtext="📥 Formato digital – acceso inmediato" className="w-full md:w-2/3 text-xl" data-id="element-92" />

            <div className="flex items-center gap-2 text-sm text-gray-400 bg-gray-800/50 px-4 py-2 rounded-lg" data-id="element-93">
              <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-94" />
              <span data-id="element-95">Garantía de satisfacción. Contenido 100% verificado.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}